import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn} from '@angular/router';
import {UserService} from '@services/user/user.service';

export const authenticatedUserGuard: CanActivateFn = async (_route, _state) => {
  const user = inject(UserService).userPromise;
  return !!(await user);
};

export const authenticatedUserChildGuard: CanActivateChildFn = async (_route, _state) => {
  const user = inject(UserService).userPromise;
  return !!(await user);
};
